// (c) chaehongee. Confidential and proprietary.

import { http, buildApiUrl } from './http'
import type { CommitResponse, CommitType } from 'models-ts/commit'

export interface CommitCreate {
  message: string
  type?: CommitType
  session_id: string
  node_to_id: string
  nodes_from_ids?: string[]
}

export async function createCommit(payload: CommitCreate): Promise<CommitResponse> {
  return http<CommitResponse>(buildApiUrl('/commit/'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      message: payload.message,
      type: payload.type ?? 'edited',
      session_id: payload.session_id,
      node_to_id: payload.node_to_id,
      nodes_from_ids: payload.nodes_from_ids ?? [],
    }),
  })
}


